module.exports = global["React"] = require("-!/Users/bobylito/source/instantsearch.js/node_modules/react/react.js");


//////////////////
// WEBPACK FOOTER
// ./~/react/react.js
// module id = 347
// module chunks = 0